<!--

@@author        j0Shi
@@date          2019.08.21
@@desc          Object placeholder that shows when object page loads
@@usedby        Object

-->

<template>
  <div class="object-loading">
    <header><nav><div class="container" /></nav></header>
    <div class="container object-breadcrumbs">
      <span class="loading-breadcrumb" />
      <span class="loading-breadcrumb" />
      <span class="loading-breadcrumb" />
      <span class="loading-breadcrumb" />
    </div>
    <main class="container">
      <article>
        <div class="card-radius" />
        <section>
          <div class="section-head" />
          <div class="section-main">
            <div class="amenities amenities-lg">
              <ul>
                <li />
                <li />
                <li />
                <li />
                <li />
                <li />
              </ul>
            </div>
            <div class="badges">
              <div class="badge">
                &nbsp;
              </div>
              <div class="badge">
                &nbsp;
              </div>
              <div class="badge">
                &nbsp;
              </div>
              <div class="badge">
                &nbsp;
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="section-head" />
          <div class="section-main">
            <p /><p /><p /><p />
          </div>
        </section>
        <section>
          <div class="section-head" />
          <div class="section-main">
            <p /><p /><p /><p />
          </div>
        </section>
      </article>
      <aside><div class="sticky" /></aside>
    </main>
  </div>
</template>

<script>
export default {
  name: 'ObjectLoading',
};
</script>

<style lang="scss" scoped>
$color1: #e1e1e1;
$color2: #909090;

.object-loading {
  header {
    padding: 20px 0;

    nav {
      padding-top: 1em;
      padding-bottom: 1em;

      div {
        height: 50px;
      }
    }
  }

  .object-breadcrumbs {
    display: flex;
    justify-content: space-between;
    padding-top: $margin_content_xs;
    padding-bottom: $margin_content_xs;

    .loading-breadcrumb {
      height: 20px;
      width: 20%;
    }
  }

  ul li {
    height: 30px;
  }

  .section-head {
    height: 40px;
  }

  .section-main p {
    height: 20px;
    width: 100%;
    display: block;
  }

  .card-radius {
    height: 350px;
  }

  aside .sticky {
    height: 500px;
  }

  .badges {
    display: flex;
    justify-content: space-between;

    .badge {
      height: 35px;
      width: 20%;
    }
  }

  header nav div,
  .loading-breadcrumb,
  .section-head,
  .card-radius,
  aside .sticky,
  ul li,
  .badges .badge,
  .section-main p {
    border-radius: 10px;
    background-color: $color1;

    /*
            -webkit-animation: PulseLoader 2s ease infinite;
            -moz-animation: PulseLoader 2s ease infinite;
            -o-animation: PulseLoader 2s ease infinite;
            animation: PulseLoader 2s ease infinite;
*/
  }
}

@-webkit-keyframes PulseLoader {
  0% { background-color: $color1; }
  50% { background-color: $color2; }
  100% { background-color: $color1; }
}

@-moz-keyframes PulseLoader {
  0% { background-color: $color1; }
  50% { background-color: $color2; }
  100% { background-color: $color1; }
}

@-o-keyframes PulseLoader {
  0% { background-color: $color1; }
  50% { background-color: $color2; }
  100% { background-color: $color1; }
}

@keyframes PulseLoader {
  0% { background-color: $color1; }
  50% { background-color: $color2; }
  100% { background-color: $color1; }
}
</style>
